import React from 'react';

import { Icon } from '@chakra-ui/react';
import { MdPerson, MdLock, MdInsights, MdPeople } from 'react-icons/md';

import Profile from 'views/admin/profile';
import Regiondata from 'views/admin/regiondata';
import SignInCentered from 'views/auth/signIn';
import Users from 'views/admin/users';
import MasterData from 'views/admin/masterdata';
import { AiOutlineWarning, AiFillOpenAI } from 'react-icons/ai';
import { LiaFileVideo } from "react-icons/lia";

import { MdPendingActions } from 'react-icons/md';
import { MdMap } from 'react-icons/md';
import { MdCloudUpload, MdFileDownload } from 'react-icons/md';
import UploadFilesSection from 'views/admin/UploadSection/index';
import UploadedFilesSection from 'views/admin/uploadedFiles/index';
import TechSupportDashboard from 'views/admin/Tech-Support/TechSupport';
import Summary from 'views/admin/Ai-powered-model/Summary';
import AllNotifications from 'views/admin/AllNotification/AllNotifications';
import AddNewModule from 'views/admin/newModule/AddNewModule';
import { VideoIcon } from 'lucide-react';
import { MdMenuBook } from "react-icons/md";
// import InformativeVideo from 'views/admin/informative/informativeVideo';
import TargetSet from 'views/admin/targetSet/TargetSet';
import InformativeVideo from 'views/admin/informative/InformativeVideo';

const user = JSON.parse(localStorage.getItem('user'));
const role = user?.role;
let haveAcess = false;

// Base routes that are always shown
const baseRoutes = [
  {
    name: 'Uploaded Data',
    layout: '/admin',
    path: '/uploaded-files',
    icon: <Icon as={MdFileDownload} w="20px" h="20px" color="inherit" />,
    component: <UploadedFilesSection />,
    secondary: true,
  },
  {
    name: 'Upload Data',
    layout: '/admin',
    path: '/uploads-files',
    icon: <Icon as={MdCloudUpload} w="20px" h="20px" color="inherit" />,
    component: <UploadFilesSection />,
    secondary: true,
  },
  {
    name: 'Master Data',
    layout: '/admin',
    path: '/masterdata',
    icon: <Icon as={MdInsights} width="20px" height="20px" color="inherit" />,
    component: <MasterData />,
    secondary: true,
  },
  {
    name: 'Users',
    layout: '/admin',
    path: '/users',
    icon: <Icon as={MdPeople} width="20px" height="20px" color="inherit" />,
    component: <Users />,
    secondary: true,
  },
  {
    name: 'Region Data',
    layout: '/admin',
    path: '/regiondata',
    icon: <Icon as={MdMap} w="20px" h="20px" color="inherit" />,
    component: <Regiondata />,
  },
  {
    name: 'Profile',
    layout: '/admin',
    path: '/profile',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <Profile />,
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInCentered />,
  },
  {
    name: 'Notifications',
    layout: '/admin',
    path: '/notifications',
    icon: <Icon as={''} width="20px" height="20px" color="inherit" />,
    component: <AllNotifications />,
  },
  // {
  //   name: 'Recovery Target Setting',
  //   layout: '/admin',
  //   path: '/recovery-target',
  //   icon: <Icon as={''} width="20px" height="20px" color="inherit"></Icon>,
  //   component: <TargetSet />
  // }

  // {
  //   name: 'Informative Videos',
  //   layout: '/admin',
  //   path: '/informative',
  //   icon: <Icon as={MdMenuBook} w="20px" h="20px" color="inherit" />,
  //   component: <InformativeVideo />,
  // }
];

// Check if user has access to PM-JANMAN scheme
const hasPmJanmanAccess = () => {
  if (!user || !user.schemes) return false;

  return user.schemes.some(scheme =>
    scheme.name && scheme.name.toUpperCase() === 'PM-JANMAN'
  );
};

// Conditionally add the Add New Module route
const allRoutes = [...baseRoutes];

// Add Add New Module route only if conditions are met
// if (role === "schemeAdmin"  && hasPmJanmanAccess()) {
//   allRoutes.push({
//     name: 'Add New Anganwadi Center ',
//     layout: '/admin',
//     path: '/add-new-module',
//     icon: <Icon as={AiOutlineWarning} width="20px" height="20px" color="inherit" />,
//     component: <AddNewModule />,
//   });
// }

if (role !== "admin") {
  allRoutes.push({
    name: 'Informative Video',
    layout: '/admin',
    path: '/informative-video',
    icon: <Icon as={VideoIcon} width="20px" height="20px" color="inherit" align="center" />,
    component: <InformativeVideo />,
  });
}

if (role === "schemeAdmin") {
  allRoutes.push({

    name: 'Recovery Target Setting',
    layout: '/admin',
    path: '/recovery-target',
    icon: <Icon as={''} width="20px" height="20px" color="inherit"></Icon>,
    component: <TargetSet />

  });
}

export default allRoutes;